'use client';

import { Switch } from '~/components/ui/switch';

type ToggleProps = {
  onCheckedChange?: (checked: boolean) => void;
  checked: boolean;
  disabled?: boolean;
  className?: string;
};

export default function Toggle(props: ToggleProps) {
  return (
    <Switch
      checked={props.checked}
      onCheckedChange={props.onCheckedChange}
      disabled={props.disabled}
      className={props.className}
    />
  );
}
